import { Card, Group, Skeleton, Stack } from '@mantine/core';

export default function ConsultCardSkeleton() {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Skeleton height={120} width="100%" radius="sm" mb="lg" />
      <Group>
        <Skeleton height={20} width="20%" radius="sm" />
        <Skeleton height={20} width="20%" radius="sm" />
        <Skeleton height={20} width="20%" radius="sm" />
      </Group>
      <Stack gap="xs" mt="md">
        <Skeleton height={20} width="80%" radius="sm" />
        <Skeleton height={15} width="60%" radius="sm" />
        <Skeleton height={15} width="60%" radius="sm" />
        <Skeleton height={20} width="80%" radius="sm" />
        <Skeleton height={30} width="100%" radius="sm" />
      </Stack>
    </Card>
  );
}
